
import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import axios from 'axios';
import Signup from './Signup';
import Configdata from './Defaultdata';

import {isvalidatemail,isvalidmob,isvaluenull,isequal} from './validation';
import { getmessage,wrongmsg,getusertype,searchpostnow,displayprofile } from './Dynamictable';
import { cityidfromcod } from './userdefaultdata';
import Usersession from './Usersession';
class Changepassword extends Component {
	constructor(props: any) {
   	super(props);
	this.state.togglesineup = false;
    	this.state.ltypeguest = false;

  	}
	state = {
        name: "",
	email:"",
	paswrd:"",
	newpswd:"",
        reentry:"",
        togglecrit: false,
        togglesineup:false,
	slcttype:false,
	ltypeguest:false,
	
    	};

	
	typeselect(e: any){
		
		this.desecttypes();
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';

		//alert(eid);
		

		e.preventDefault()

	};
	usersineup(e: any){
	   try {
		
		const signups = <Signup />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		if(maindiv){
		ReactDOM.render(signups,maindiv);
		maindiv.style.display = 'block';
	        }
		if(Pdivr){
		Pdivr.style.display = 'none';
		}
		//alert(maindiv.style.display);
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};
	paswdctrlsvalidate(){
	 let isvalid = true;
		
		if(!isequal(this.state.newpswd,this.state.reentry)){
		 getmessage('Re enter password not matched','');
	  	return false;
		}
		  	
	return isvalid;
	}
	

	desecttypes(){
		this.setState({ slcttype: false });
		

		
	}
	
	
	

	componentDidMount() {
        //debugger;
     	 //this.guestlogindivshow();

     
    	}

	changepswd(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	//alert(id);
        if(id == 'txtpswd'){
        
	 this.setState({ paswrd: elvalue });
	}
	else if(id == 'txtnewpswd'){
	
	 this.setState({ newpswd: elvalue });
	}
	
	else if(id == 'txtreentrypswd'){
	
	 this.setState({ reentry: elvalue });
	
	}
	
   }

setpassword(e:any){

  try {
		if(this.paswdctrlsvalidate()){
          	getmessage('On Process Please wait.....','');	
		//alert(localStorage.getItem("id"));
		const userpaswrd = this.state.paswrd;
		const newpswrd = this.state.newpswd;
                const response = axios.post(Configdata.srvurl + '/userpaswordupdate', {
    		pswd: userpaswrd,
    		newpswd: newpswrd,
		userid:0,
		upin:localStorage.getItem("id")
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		
		if(usercd == 'NA'){
		getmessage('Please try again','');
		}
		else{
		getmessage(usercd,'');
		displayprofile();
		}
		
		
	        });		
              }
		
	   }
          }
        catch (e) {
           // debugger;
		wrongmsg();
        }
  		
  e.preventDefault()
}

getdatasearch(){
	 try {
        const ctyid = Usersession.getCityId();
	//alert(ctyid);
        let service = '/getlandposts?prd=1&ctd='+ctyid+'&ltd=1&tpd=1';	
	//alert(service);
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
               
		const tdata = response.data;
		searchpostnow(tdata);
		
		this.closeprofilediv();
             	//const udata = JSON.parse(tdata);

		//const udata = reducearray(tdata);
		//alert(tdata);
		//setsearch(tdata);
            })
            .catch((err: any) => {
                getmessage('Something went wrong','');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	
     closeprofilediv(){
	const Pdivr = document.getElementById('profilediv') as HTMLElement;
	Pdivr.style.display ='none';
     }

	render() {
		return (
		<form>
			
                <div id="sinupsidebardiv" className="sidebar-search" style={{width:'80vw'}}>

		     <div className="search-title-bar">
                       	<div className="search-title">
			Change Password			  
			</div>
			
	   	     </div>
		  <div id="selectlogintype" className="sidebar-scroll">
		   	
		     
		   <div className="sidebar-basic-info" id="upassworddiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginpswrd" style={{width:'94%'}}>
			  <input placeholder="Enter Your Password"  onChange={e => this.changepswd(e)} id="txtpswd" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>

		   <div className="sidebar-basic-info" id="unewpswddiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginuseremail" style={{width:'94%'}}>
			 <input placeholder="Enter New Password"  onChange={e => this.changepswd(e)} id="txtnewpswd" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
		     <div className="sidebar-basic-info" id="reentrypassdiv" style={{width:'90%',marginTop:'3vh'}}>
		       <div>	
			 <div className="searchtype" id="userpassworddiv" style={{width:'94%'}}>
		 <input placeholder="Re Enter password"  onChange={e => this.changepswd(e)} id="txtreentrypswd" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
	
		   
		   	
		     <div className="sidebar-basic-info" style={{width:'100%' ,marginTop:'5vh',height:'60px'}}>
		       <div> 
			

                       	<div id="signupdiv" style={{width:'55%',float:'left',padding:'10px'}}>
			<a href="#" onClick={e => this.typeselect(e)} title="forgot password">forgot password</a> &nbsp;&nbsp;&nbsp;
			<a href="#" onClick={e => this.usersineup(e)} title="SignUp">SignUp</a> &nbsp;
			
			

			</div>
			
			<a href="#" onClick={e => this.setpassword(e)} title="Sale">

			<div className="searchtype" id="submitpassword" style={{width:'28%',float:'left'}}>
			  Submit	
			</div>
			</a>
		     </div>
		    </div>

 		   


		 </div>
	      </div>

		

		</form>
		);
	}

	
}

export default Changepassword;
